import { Component, ElementRef, Inject, InjectionToken, NgZone, PLATFORM_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIChart } from 'primeng/chart';

/**
 This extended version of the PrimeNG Chart component fixes browser freezing when a modal is overlaid on the chart.
 It solves this by wrapping the Chart.js constructor within zone.runOutsideAngular.
 */
@Component({
  selector: 'shared-ui-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './iriro-ui-chart.component.html',
  styleUrls: ['./iriro-ui-chart.component.scss']
})
export class IriroUiChartComponent extends UIChart {

  constructor(
    private _zone: NgZone,
    @Inject(PLATFORM_ID) platformID: InjectionToken<NonNullable<unknown>>,
    elementRef: ElementRef
  ) {
    super(platformID, elementRef, _zone);
  }

  override initChart() {
    this._zone.runOutsideAngular(() => super.initChart());
  }
}
